import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  getSourceCards: () => ({
    url: 'cardtransfer/api/v1/user/SourceCards',
    method: 'GET',
  }),
  getDestinationCards: () => ({
    url: 'cardtransfer/api/v1/user/DestinationCards',
    method: 'GET',
  }),
  getDestinationCardInfo: (input) => ({
    url: 'CardTransfer/api/v1/Shaparak/CardHolder/Inquiry',
    method: 'POST',
    data: input,
  }),
  sendCardTransferPin: (input) => ({
    url: 'cardtransfer/api/v1/Harim',
    method: 'POST',
    data: input,
  }),
  saveDestinationCard: (input) => ({
    url: 'cardtransfer/api/v1/user/DestinationCards',
    method: 'POST',
    data: input,
  }),
  getCardBins: () => ({
    url: 'cardtransfer/api/v1/bins',
    method: 'GET',
  }),
  cardTransfer: (input) => ({
    url: 'cardTransfer/api/v1/Shaparak/Transfer',
    method: 'POST',
    data: input,
    headers: {
      'Content-Type': 'text/plain',
    },
  }),
  cardReactivation: () => ({
    url: 'CardTransfer/api/v1/Tsm/CardReactivation',
    method: 'POST',
  }),
  cardEnrollment: () => ({
    url: 'CardTransfer/api/v1/Tsm/CardEnrollment',
    method: 'POST',
  }),
  getCardInfo: (input) => ({
    url: 'CardTransfer/api/v1/Tsm/CardInfo',
    method: 'POST',
    data: input,
  }),
  getC2CTransactions: (input) => ({
    url: 'cardtransfer/api/v1/user/Transaction/Report',
    method: 'GET',
    params: input,
  }),
  removeCard: (input) => ({
    url: 'cardtransfer/api/v1/user/DestinationCard/Remove',
    method: 'PUT',
    data: input,
  }),
  getTransferDetail: (input) => ({
    url: `cardtransfer/api/v1/user/Transaction/Report/${input?.id}`,
    method: 'GET',
  }),
  inquireLastTransaction: (input) => ({
    url: `CardTransfer/api/v1/Shaparak/Transaction/Inquiry`,
    method: 'POST',
    data: input,
  }),
};

export default apis;
